import Layout from '../../components/Layout';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../blogPosts';

function Blog() {
  return (
    <Layout>
      <Helmet>
        <title>Rojan Thomas — Software Engineer</title>
        <meta name="description" content="Rojan Thomas — Senior Software Engineer. Blog, portfolio, and personal projects." />
      </Helmet>
      {/* Page title */}
      <Box
        sx={{
          marginBottom: 3,
          paddingBottom: 2.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: 1.5,
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
            fontWeight: 500,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          Blog
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.5,
            fontSize: '0.9rem',
          }}
        >
          Thoughts on Android development, Kotlin, and software engineering.
        </Typography>
      </Box>

      {/* Blog posts list */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {blogPosts.map((post) => (
          <MuiLink
            key={post.slug}
            component={Link}
            to={`/blog/${post.slug}`}
            sx={{
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                padding: 2,
                border: '1px solid',
                borderColor: 'divider',
                transition: 'all 0.2s ease',
                flexDirection: { xs: 'column', sm: 'row' },
                textAlign: { xs: 'center', sm: 'left' },
                '&:hover': {
                  borderColor: 'text.primary',
                },
              }}
            >
              {post.icon ? (
                <Box
                  component="img"
                  src={post.icon}
                  alt={`${post.title} icon`}
                  sx={{
                    width: { xs: 50, sm: 40 },
                    height: { xs: 50, sm: 40 },
                    borderRadius: '50%',
                    flexShrink: 0,
                  }}
                />
              ) : (
                <ArticleOutlinedIcon
                  sx={{
                    width: { xs: 50, sm: 40 },
                    height: { xs: 50, sm: 40 },
                    color: 'text.secondary',
                    flexShrink: 0,
                  }}
                />
              )}
              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: '1.1rem', sm: '1.25rem' },
                    fontWeight: 600,
                    marginBottom: 0.5,
                  }}
                >
                  {post.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    fontSize: '0.85rem',
                    marginBottom: 1,
                  }}
                >
                  {new Date(post.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    lineHeight: 1.5,
                    fontSize: '0.9rem',
                  }}
                >
                  {post.description}
                </Typography>
              </Box>
            </Box>
          </MuiLink>
        ))}
      </Box>
    </Layout>
  );
}

export default Blog;
